<div *ngIf="!!menuInfo" class="custom">
  <ng-container *transloco="let t; read i18nScope">
    <div class="modal-header with-subtitle cfs-menu-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancel()"></button>

      <div class="cfs-menu-brand">
        <div class="cfs-menu-brand__logo">
          <img *ngIf="menuInfo.brand.logo; else logoFallback" [src]="menuInfo.brand.logo" [alt]="menuInfo.brand.name" />
          <ng-template #logoFallback>
            <span class="cfs-menu-brand__initial">{{ menuInfo.brand.name?.charAt(0) }}</span>
          </ng-template>
        </div>

        <h5 class="modal-title cfs-menu-title m-0">{{ menuInfo.brand.name }}</h5>

        <span class="cfs-menu-lead">{{ t("title") }}</span>
      </div>

      <p class="modal-subtitle cfs-menu-cta m-0">{{ callToAction || t("subtitle") }}</p>
    </div>

    <div class="modal-body">
      <div *ngIf="menuInfo.items?.length; else emptyTpl" class="menu">
        <div
          *ngFor="let menuItem of menuInfo.items"
          class="menu-item"
          [class.disabled]="!menuItem.pageUrl"
          (click)="onMenuItemClick(menuItem)">
          <div class="menu-item__content">
            <img [src]="menuItem.icon" alt="icon" class="menu-item__icon" />
            <span class="menu-item__title">{{ menuItem.title }}</span>
          </div>
        </div>
      </div>

      <ng-template #emptyTpl>
        <div class="cfs-menu-empty">
          <img class="cfs-menu-empty__icon" src="assets/images/cfs-menu-empty.svg" alt="" />
          <span class="cfs-menu-empty__text">{{ t("empty") }}</span>
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>
